import React, { useRef, useState , useEffect} from 'react'
import logo from '../Images/logo-main-black.png'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert'
import '../firebase';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope} from '@fortawesome/free-solid-svg-icons'

function Recoverpass() {
    const emailRef = useRef();
    const [showAlertError, setShowAlertError] = useState(false)
    const [showAlert, setShowAlert] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [showSignInbtn, setShowSignInbtn] = useState(true);

    const [therrorMessage, setErrorMessage] = useState("");
    const [thesuccessMessage, setSuccessMessage] = useState("");
    const videoRef = useRef(null); // Reference for the video element
    const [isMobile, setIsMobile] = useState(() => (
      typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    ));


    function passwordReset(event){
        if (event) {
            event.preventDefault();
        }

        setShowAlert(false);
        setShowAlertError(false);
        setShowSignInbtn(false)
        setShowProgress(true);

        const email = emailRef.current.value.trim();

        if (!email) {
            setErrorMessage("Enter the email address linked to your account.")
            setShowAlertError(true);
            setShowProgress(false);
            setShowSignInbtn(true)
            return;
        }

        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
        .then(() => {
            // Password reset email sent!
            setSuccessMessage("Password reset email sent successfully. Open your email and follow the reset link to choose a new password.");
            setShowAlert(true);
            setShowSignInbtn(true)
            setShowProgress(false);
        })
        .catch((error) => {

            const errorCode = error.code;
            let errorMessage;
            switch (errorCode) {
            case "auth/user-not-found":
                errorMessage = "No user found with this email address.";
                break;
            case "auth/invalid-email":
                errorMessage = "Invalid email format. Please check and try again.";
                break;
            case "auth/too-many-requests":
                errorMessage = "Too many requests. Please wait and try again later.";
                break;
            default:
                errorMessage = "An error occurred. Please try again.";
            }

            setErrorMessage(errorMessage) 
            setShowAlertError(true);
            setShowProgress(false);
            setShowSignInbtn(true)
            // ..
        });
    }

    useEffect(() => {
        const updateIsMobile = () => {
          setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', updateIsMobile);
        updateIsMobile();

        return () => window.removeEventListener('resize', updateIsMobile);
    }, []);

    useEffect(() => {
        if (isMobile || !videoRef.current) {
          return;
        }

        // Attempt to programmatically play the video
        if (videoRef.current) {
          videoRef.current
            .play()
            .catch(error => console.error("Autoplay blocked:", error));
        }
    }, [isMobile]); // Runs when the viewport changes

  return (
    <div className='d-flex loginContainer'>
        <div className='resetleft'>
            <Link to="/"><img src={logo} alt="" className='loginLogo' /></Link>        
            <h5 className='welTxt'>Forgot your password?</h5>  
            <h6>Enter your email address and we will send you a secure password reset link.</h6> 

            <Form onSubmit={passwordReset} className='authFormShell'>
            <Form.Label className="inputLabel">Email</Form.Label>
            <InputGroup className="mb-3 loginInputGroup">               
            <InputGroup.Text id="recover-email-addon" className="loginInputAddon">
                <FontAwesomeIcon icon={faEnvelope} className="theLoginIcon"/>
            </InputGroup.Text>
                    <Form.Control
                    placeholder="Enter your email"
                    aria-label="Enter your email"
                    type="email"
                    aria-describedby="recover-email-addon"
                    className='loginForm'
                    ref={emailRef}
                    autoComplete="email"
                    spellCheck={false}
                    autoFocus
                    />
            </InputGroup> 

            {showAlert && 
                <Alert variant={'success'}  >
                    {thesuccessMessage}
                </Alert>
            }

            {showAlertError && 
                <Alert variant={'danger'}  >
                    {therrorMessage}
                </Alert>
            }
            
            <div className='authMetaRow authMetaRowSingle'>
                <p className="text-muted mb-0"><Link to="/login" className='fgPassLink text-muted'>Back to Sign In</Link></p>
            </div>
            {showSignInbtn && 
                <button variant="primary" type="submit" className='signInbtnn'>
                    Send Reset Link
                </button>  
            }

            {showProgress && 
                <Button variant="primary" disabled className='signInbtnnLoading'>
                    <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    />
                    <span> Submitting...</span>
                </Button>
            }
            </Form>
        </div>  
        
        {!isMobile && (
          <div className='loginLeft'>
            <video
              ref={videoRef}
              src="https://res.cloudinary.com/ubunifu/video/upload/v1607186910/pexels-rodnae-productions-5923291_jd1rwl.mp4"
              muted
              autoPlay
              loop
              playsInline
            ></video>
          </div>
        )}


    </div>
  )
}

export default Recoverpass
